var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1594 27.8287H4.40039V7.86719H8.69249V23.9601H23.1594V27.8266V27.8287Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1586 11.7331C25.2731 11.7331 26.9872 10.0019 26.9872 7.86651C26.9872 5.7311 25.2731 4 23.1586 4C21.0442 4 19.3301 5.7311 19.3301 7.86651C19.3301 10.0019 21.0442 11.7331 23.1586 11.7331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaWhite);
export default __webpack_public_path__ + "static/media/linea-white.360bc83c2ff96baaf0582c5a39c7f5ea.svg";
export { ForwardRef as ReactComponent };